import * as _ from 'lodash';

import { CONSTANTS } from '../shared/constants';
import { Label } from '../administration/label-management/label';

const LOCALSTORAGE_MODULE = 'labels';
export class TraslateUtils {
  static labels: Label[] = JSON.parse(localStorage.getItem(LOCALSTORAGE_MODULE));
  /**
   * @description get the traslation of a label
   * @param {string} label label to get the traslation
   * @param {string} [module] Module in tagWep3 file where label will be taken
   * @returns {string} return the traslated label.
   */
  public static getTraslatedName(componentName: string, module?: string): string {
    if (!this.labels) {
      this.labels = JSON.parse(localStorage.getItem(LOCALSTORAGE_MODULE));
    }
    let selectedLabel: Label;
    let traslatedLabel: string;
    selectedLabel = _.find(TraslateUtils.labels, (label: Label) => {
      const condition = (module) ? _.isEqual(label.key, componentName) && _.isEqual(label.module, module)
        : _.isEqual(label.key, componentName);
      return condition;
    });
    traslatedLabel = selectedLabel ? selectedLabel.label : componentName;
    return traslatedLabel;
  }

  /**
   * @description get the traslation names of the list
   * @param {any[]} listNames list which will be traslate
   * @param {string} [field] Field to translate
   * @param {string} [targetField] Field to set the translated result
   * @param {string} [module] Module in tagWep3 file where label will be taken
   * @returns {any[]} list with the names traslated
   */
  public static getTraslatedNames(listNames: any[], field?: string, targetField?: string, module?: string): any[] {
    field = _.isUndefined(field) ? 'name' : field;
    targetField = _.isUndefined(targetField) ? 'translatedName' : targetField;
    _.forEach(listNames, (row: any, index: number) => {
      listNames[index][targetField] = this.getTraslatedName(row[field], module);
    });
    return listNames;
  }

  /**
   * @description Gets the traslation name of field/subfield in list
   * @param {any[]} array - list which will be traslate
   * @param {string} field - Field to translate. If subfield is define, this will be the parent of subfield param
   * @param {string} subfield - If it's define, this will be the field to traslate, is child of field param
   * @param {string} targetField - Field to set the translated result
   * @param {string} module - Module in tagWep3 file where label will be taken
   * @returns {any[]} list with the names traslated
   */
  public static getTranslatedNamesOf(array: any[], field?: string, subfield?: string, targetField?: string,
    module?: string): any[] {
    field = _.isUndefined(field) ? CONSTANTS.NAME : field;
    targetField = _.isUndefined(targetField) ? CONSTANTS.TRANSLATED_NAME : targetField;
    _.forEach(array, (row: any, index: number) => {
      if (_.isNil(subfield)) {
        array[index][targetField] = this.getTraslatedName(row[field], module);
      } else {
        array[index][field][targetField] = this.getTraslatedName(row[field][subfield], module);
      }
    });
    return array;
  }
}
